/**
 * Elevate light haptics — zero work when unsupported.
 * Android Chrome: short vibrate pulses.
 * iOS Safari: no public vibration API (safe no-op).
 * Desktop mouse: skipped (no pointless vibrate calls).
 */
(function () {
  if (window.ElevateHaptics) return;

  var enabled = true;
  var lastAt = 0;
  var minGap = 55;
  var supported =
    typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';

  function prefersReduce() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function pulse(pattern) {
    if (!enabled || !supported || prefersReduce()) return false;
    var now = Date.now();
    if (now - lastAt < minGap) return false;
    lastAt = now;
    try {
      return navigator.vibrate(pattern);
    } catch (e) {
      return false;
    }
  }

  window.ElevateHaptics = {
    tick: function () {
      return pulse(8);
    },
    select: function () {
      return pulse(12);
    },
    confirm: function () {
      return pulse([10, 28, 12]);
    },
    warn: function () {
      return pulse([16, 36, 16]);
    },
    off: function () {
      enabled = false;
    },
    on: function () {
      enabled = true;
    },
  };

  // Sparse delegated taps — touch/pen only, cheap closest() check
  var SELECTOR =
    '.button, .shopify-payment-button__button, button.quick-add__submit, .header__icon, .quantity__button, a.elevate-categories__card, .pagination__item';

  document.addEventListener(
    'pointerdown',
    function (e) {
      if (!supported || !enabled) return;
      if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
      var t = e.target;
      if (!t || !t.closest) return;
      var el = t.closest(SELECTOR);
      if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return;

      if (
        el.matches(
          '.button--primary, .button[name="add"], .shopify-payment-button__button, .quick-add__submit'
        )
      ) {
        window.ElevateHaptics.confirm();
      } else {
        window.ElevateHaptics.tick();
      }
    },
    { passive: true }
  );
})();
